//App

import { OrganizationCampaignDto } from "../app/model/api/types/dto/organizationCampaignDto";

export class CampaignViewModel {
    id?: string | null;
    organizationId: Array<string> | null;
    organization?: string | null;
    name: string | null;
    description: string | null;
    code: string | null;
    startDate: string | null;
    endDate: string | null;
    donationStartDate: string | null;
    creditCardStartDate: string | null;
    creditCardEndDate: string | null;
    checkStartDate: string | null;
    checkEndDate: string | null;
    payrollDeductionStartDate: string | null;
    payrollDeductionEndDate: string | null;
    pledgeGoal: number | null;
    isActive: boolean | null;

    constructor(
        id: string | null,
        organizationId: Array<string> | null,
        name: string | null,
        organization: string | null,
        code: string | null,
        description: string | null,
        startDate: string | null,
        endDate: string | null,
        donationStartDate: string | null,
        creditCardStartDate: string | null,
        creditCardEndDate: string | null,
        checkStartDate: string | null,
        checkEndDate: string | null,
        payrollDeductionStartDate: string | null,
        payrollDeductionEndDate: string | null,
        pledgeGoal: number | null,
        isActive: boolean | null,
    ) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.organizationId = organizationId;
        this.organization = organization;
        this.code = code;
        this.startDate = startDate;
        this.donationStartDate = donationStartDate;
        this.creditCardStartDate = creditCardStartDate;
        this.creditCardEndDate = creditCardEndDate;
        this.checkStartDate = checkStartDate;
        this.checkEndDate = checkEndDate;
        this.payrollDeductionStartDate = payrollDeductionStartDate;
        this.payrollDeductionEndDate = payrollDeductionEndDate;
        this.pledgeGoal = pledgeGoal;
        this.endDate = endDate;
        this.isActive = isActive;

    }

    toDto(): OrganizationCampaignDto {
        return {
            id: this.id,
            organizationId: this.organizationId !== null && this.organizationId?.length > 0 ? this.organizationId[0] : null,
            name: this.name,
            description: this.description,
            code: this.code,
            startDate: this.startDate === "" ? null : this.startDate,
            endDate: this.endDate === "" ? null : this.endDate,
            donationStartDate: this.donationStartDate === "" ? null : this.donationStartDate,
            creditCardStartDate: this.creditCardStartDate === "" ? null : this.creditCardStartDate,
            creditCardEndDate: this.creditCardEndDate === "" ? null : this.creditCardEndDate,
            checkStartDate: this.checkStartDate === "" ? null : this.checkStartDate,
            checkEndDate: this.checkEndDate === "" ? null : this.checkEndDate,
            payrollDeductionStartDate: this.payrollDeductionStartDate === "" ? null : this.payrollDeductionStartDate,
            payrollDeductionEndDate: this.payrollDeductionEndDate === "" ? null : this.payrollDeductionEndDate,
            pledgeGoal: this.pledgeGoal,
            isActive: this.isActive,
        };
    }

    mapFromDto(dto: OrganizationCampaignDto): void {
        this.id = dto.id;
        dto.organizationId !== null ? this.organizationId?.push(dto?.organizationId??"") : (this.organizationId = null);
        this.name = dto.name;
        this.description = dto.description;
        this.code = dto.code;
        this.startDate = dto.startDate;
        this.endDate = dto.endDate;
        this.donationStartDate = dto.donationStartDate;
        this.creditCardStartDate = dto.creditCardStartDate ?? null;
        this.creditCardEndDate = dto.creditCardEndDate ?? null;
        this.checkStartDate = dto.checkStartDate ?? null;
        this.checkEndDate = dto.checkEndDate ?? null;
        this.payrollDeductionStartDate = dto.payrollDeductionStartDate ?? null;
        this.payrollDeductionEndDate = dto.payrollDeductionEndDate ?? null;
        this.pledgeGoal = dto.pledgeGoal;
        this.isActive = dto.isActive || true;
    }
}
